<ng-container *ngIf="vm != null; else authLoading">

	<nav class="navbar">
		<a class="logo" routerLink="/">
			<div class="logo-mark">
				<img class="logo-img" src="/assets/logo-trans.png" alt="Omniscient Forge logo" width="44" height="44"
					decoding="async" />
			</div>
			<div class="logo-text">
				<span>OMNISCIENT</span>
				<span class="forge">FORGE</span>
			</div>
		</a>
	
		<div class="nav-actions">
			<a *ngIf="vm.pendingRequests && vm.pendingRequests > 0" class="nav-alert"
				routerLink="/workspace/admin/access-requests" aria-label="Review access requests">
				<span aria-hidden="true">!</span>
			</a>
			<button type="button" class="icon-button"
				[attr.aria-label]="vm.themeMode === 'dark' ? 'Enable light mode' : 'Enable dark mode'"
				(click)="toggleTheme()">
				<ng-container [ngSwitch]="vm.themeMode">
					<svg *ngSwitchCase="'dark'" aria-hidden="true" viewBox="0 0 24 24" width="20" height="20" fill="none"
						stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
						<circle cx="12" cy="12" r="4.25" />
						<path
							d="M12 2.5v2.5M12 19v2.5M4.5 12H2M22 12h-2.5M6.4 6.4 4.9 4.9M19.1 19.1l-1.5-1.5M6.4 17.6 4.9 19.1M19.1 4.9l-1.5 1.5" />
					</svg>
					<svg *ngSwitchDefault aria-hidden="true" viewBox="0 0 24 24" width="20" height="20" fill="none"
						stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
						<path d="M20 14.5a7.5 7.5 0 1 1-8.5-12 7.5 7.5 0 0 0 8.5 12Z" />
					</svg>
				</ng-container>
			</button>
			<button type="button" class="user-avatar" [attr.aria-label]="vm.isAuthenticated ? vm.avatarLabel : 'Account'"
				(click)="accountAction(vm)">
				<ng-container *ngIf="vm.isAuthenticated && vm.avatarPictureUri; else accountIcon">
					<img [src]="vm.avatarPictureUri" alt="User avatar" class="avatar-img" />
				</ng-container>
				<ng-template #accountIcon>
					<svg aria-hidden="true" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor"
						stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
						<circle cx="12" cy="8.5" r="3.5" />
						<path d="M5 19c1.5-2.3 4-3.5 7-3.5s5.5 1.2 7 3.5" />
					</svg>
				</ng-template>
			</button>
		</div>
	</nav>

</ng-container>

<ng-template #authLoading>
	<nav class="navbar">
		<a class="logo" routerLink="/">
			<div class="logo-mark">
				<img class="logo-img" src="/assets/logo-trans.png" alt="Omniscient Forge logo" width="44" height="44"
					decoding="async" />
			</div>
			<div class="logo-text">
				<span>OMNISCIENT</span>
				<span class="forge">FORGE</span>
			</div>
		</a>
		<div class="nav-actions">
			<button type="button" class="icon-button" aria-label="Toggle theme" (click)="toggleTheme()">
				<svg aria-hidden="true" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor"
					stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
					<circle cx="12" cy="12" r="4.25" />
					<path
						d="M12 2.5v2.5M12 19v2.5M4.5 12H2M22 12h-2.5M6.4 6.4 4.9 4.9M19.1 19.1l-1.5-1.5M6.4 17.6 4.9 19.1M19.1 4.9l-1.5 1.5" />
				</svg>
			</button>
			<button type="button" class="user-avatar" aria-label="Account" disabled>
				<svg aria-hidden="true" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor"
					stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
					<circle cx="12" cy="8.5" r="3.5" />
					<path d="M5 19c1.5-2.3 4-3.5 7-3.5s5.5 1.2 7 3.5" />
				</svg>
			</button>
		</div>
	</nav>
</ng-template>
